import React, { useEffect, useState } from "react";
import "../Home/Home.css";
import { motion as m } from "framer-motion";
import { All_Projects } from "../../Config";
import { useParams } from "react-router-dom";
import { Tooltip } from "antd";
import { IoIosArrowForward } from "react-icons/io";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
// import { LiaNode } from "react-icons/lia";
// import { SiReact } from "react-icons/si";
// import { RiTailwindCssFill } from "react-icons/ri";
// import { PiFigmaLogoFill } from "react-icons/pi";
// import { ImSvg } from "react-icons/im";
// import { TbSeo } from "react-icons/tb";

const ProjectCaseStudy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [activeView, setActiveView] = useState("laptop");
  const [isMobileScreen, setIsMobileScreen] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      const mobile = window.innerWidth < 768;
      setIsMobileScreen(mobile);
      setActiveView(mobile ? "mobile" : "laptop");
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  // const [isPaused_laptop, setIsPaused_laptop] = useState(false);
  // const [isPaused_mobile, setIsPaused_mobile] = useState(false);

  const [current_laptop, setCurrent_laptop] = useState(0);
  const [current_mobile, setCurrent_mobile] = useState(0);

  const { caseStudyLink } = useParams();

  const project = All_Projects.find(
    (project) => project.caseStudyLink === caseStudyLink,
  );

  const isImageScroll_Project =
    project.caseStudyLink === "neel-ayurvedics" ||
    project.caseStudyLink === "dresswala-nx";

  if (!project) {
    return (
      <div className="bg-white dark:bg-black transition-all duration-300 ease-in-out text-center pt-40 text-xl text-red-600">
        Project Not Found!
      </div>
    );
  }

  //   const iconMapping = [
  //     {
  //       names: ["On-page SEO", "Off-page SEO", "Technical Page SEO"],
  //       icon: TbSeo,
  //       color: "text-blue-500",
  //       animate: { x: [20, 10, 20], y: [0, 10, 0] },
  //       position: "absolute bottom-8 right-8",
  //     },
  //     {
  //       names: ["Google Ads Management", "Ads Management", "Google Campaigns"],
  //       icon: LiaNode,
  //       color: "text-green-600",
  //       animate: { x: [0, 10, 0], y: [0, -10, 0] },
  //       position: "absolute top-6 left-2",
  //     },
  //     {
  //       names: ["Backlinking", "Link Building", "External SEO"],
  //       icon: RiTailwindCssFill,
  //       color: "text-sky-400",
  //       animate: { x: [0, 10, 0], y: [0, 10, 0] },
  //       position: "absolute top-40 -left-5 lg:-left-8",
  //     },
  //     {
  //       names: ["Design", "UI/UX", "Figma", "Prototype"],
  //       icon: PiFigmaLogoFill,
  //       color: "text-pink-400",
  //       animate: { x: [20, 10, 20], y: [10, 10, 10] },
  //       position: "absolute -bottom-2 left-16",
  //     },
  //     {
  //       names: ["React", "Frontend", "SPA Development"],
  //       icon: SiReact,
  //       color: "text-teal-300",
  //       animate: { x: [0, -10, 0], y: [0, -10, 0] },
  //       position: "absolute -top-3 right-16",
  //     },
  //     {
  //       names: ["SVG", "Illustration", "Vector"],
  //       icon: ImSvg,
  //       color: "text-amber-500",
  //       animate: { x: [10, 10, 10], y: [0, 10, 0] },
  //       position: "absolute top-20 -right-2",
  //     },
  //   ];

  const images_laptop = project.images_laptop || [];

  // const images_laptop = [
  //   "../assets/Init_sohamWeb_home.png",
  //   "../assets/Init_sohamWeb_villas.png",
  //   "../assets/Init_sohamWeb_propertyManagement.png",
  // ];

  const transitionDuration = 0.8;

  const goNext_laptop = () => {
    setCurrent_laptop((prev) => (prev + 1) % images_laptop.length);
  };

  const goPrev_laptop = () => {
    setCurrent_laptop(
      (prev) => (prev - 1 + images_laptop.length) % images_laptop.length,
    );
  };

  // ---------------- MOBILE CAROUSEL ----------------
  const images_mobile = project.images_mobile || [];

  // const images_mobile = [
  //   "../assets/Init_sohamMob_home.png",
  //   "../assets/Init_sohamMob_apartments.png",
  //   "../assets/Init_sohamMob_propertyManagement.png",
  // ];

  const goNext_mobile = () => {
    setCurrent_mobile((prev) => (prev + 1) % images_mobile.length);
  };

  const goPrev_mobile = () => {
    setCurrent_mobile(
      (prev) => (prev - 1 + images_mobile.length) % images_mobile.length,
    );
  };

  const hasMobile = images_mobile.length > 0;
  const hasLaptop = images_laptop.length > 0;

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 0.5, 1] }}
      transition={{ duration: 0.9, ease: "easeIn" }}
      style={{ willChange: "opacity" }}
    >
      <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
        {/* Banner */}
        <div className="px-5 lg:px-[7%] 2xl:px-[13%] py-10 pt-32">
          {/* <div className="card_titleBanner relative w-full pt-14 pb-12 group rounded-lg overflow-hidden flex flex-col bg-gray-100 text-gray-900 dark:bg-neutral-800 border border-gray-100 dark:border-gray-800 text-left p-3 dark:text-gray-50 text-base font-bold transition-all duration-300 ease-in-out">
            <div className="flex flex-col sm:items-center">
              <p className="font-semibold uppercase text-3xl lg:text-4xl transition-all duration-200 ease-in-out">
                Project Case Study
                <span className="flex h-0.5 w-10 mt-0.5 bg-teal-600 rounded-full" />
              </p>

              <p className="flex items-center gap-1 mt-3 text-sm">
                Home <IoIosArrowForward className="text-teal-600" />
                Our Services <IoIosArrowForward className="text-teal-600" />
                <i>Project Case Study</i>
              </p>
            </div>
          </div> */}

          <p className="flex items-center gap-1 text-xs">
            Home <IoIosArrowForward className="text-teal-600" />
            Our Services <IoIosArrowForward className="text-teal-600" />
            <i>Project Case Study</i>
          </p>
        </div>

        {/* Content */}
        <div className="px-5 lg:px-[7%] 2xl:px-[13%] pb-10">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-10 xl:gap-[10%]">
            <div className="order-2 lg:order-1">
              <div className="flex items-center -ml-3">
                <div className="h-[3px] w-6 bg-teal-600 rotate-90 rounded-t-sm" />
                <p className="font-semibold uppercase text-3xl transition-all duration-200 ease-in-out">
                  {project.name}
                </p>
              </div>

              <div className="flex flex-wrap items-center text-center gap-2 text-xs 2xl:text-lg mt-3">
                {project.features.map((feature, featureIndex) => (
                  <p
                    key={featureIndex}
                    className={`bg-opacity-65 text-white py-1 px-3 rounded-full 
                  ${
                    feature === "Website" ||
                    feature === "E-commerce Website" ||
                    feature === "App"
                      ? "bg-[#008080]"
                      : feature === "Admin Panel" || feature === "Web-app"
                        ? "bg-[#635BFF]"
                        : feature === "Management Services"
                          ? "bg-[#181885]"
                          : feature === "SEO"
                            ? "bg-[#4F9CF9]"
                            : feature === "Content Writing"
                              ? "bg-[#8e9db8]"
                              : ""
                  }`}
                  >
                    {feature}
                  </p>
                ))}
              </div>

              <div className="my-10 space-y-5">
                {project.timeframe && (
                  <div>
                    <p>Timeframe:</p>
                    <p className="font-semibold text-lg">{project.timeframe}</p>
                  </div>
                )}

                {/* <div>
                  <p>Timeframe:</p>
                  <p className="font-semibold text-lg">{project.timeframe}</p>
                </div> */}

                <div>
                  <p>Init Technology Role:</p>
                  <p className="font-semibold text-lg">{project.role}</p>
                </div>
              </div>

              <p>{project.description}</p>
            </div>

            <div className="relative flex aspect-square justify-self-center border border-gray-400 border-dashed rounded-full p-5 lg:mt-5 order-1 lg:order-2">
              <div className="bg-gray-100/10 rounded-full shadow-newcustom">
                {/* Light Logo */}
                <img
                  src={project.logo}
                  alt="project-logo"
                  loading="lazy"
                  className="max-w-60 max-h-60 sm:max-w-72 sm:max-h-72 2xl:max-w-96 2xl:max-h-96 aspect-[1/1] object-contain dark:hidden scale-[0.85] hover:scale-90 transition-all duration-300 ease-in-out"
                />

                {/* Dark Logo */}
                <img
                  src={project.white_logo}
                  alt="project-logo-dark"
                  loading="lazy"
                  className="max-w-60 max-h-60 sm:max-w-72 sm:max-h-72 2xl:max-w-96 2xl:max-h-96 aspect-[1/1] object-contain hidden dark:block scale-[0.85] hover:scale-90 transition-all duration-300 ease-in-out"
                />
              </div>

              <>
                {project.iconMapping.map((item, index) => {
                  const IconComponent = item.icon;

                  return (
                    <Tooltip
                      key={index}
                      title={<span className="text-white">{item.title}</span>}
                      color="#008080"
                      placement="bottom"
                    >
                      <m.div
                        animate={item.animate}
                        transition={{
                          duration: 5,
                          repeat: 3,
                          ease: "easeInOut",
                        }}
                        className={`absolute ${item.position}`}
                      >
                        <IconComponent
                          className={`${item.color} text-4xl lg:text-[45px] bg-white dark:bg-black shadow-newcustom dark:shadow-white rounded-full m-0.5 p-2 transition-all duration-300 ease-in-out`}
                        />
                      </m.div>
                    </Tooltip>
                  );
                })}

                {/* <m.div
                animate={{
                  x: [0, 10, 0],
                  y: [0, -10, 0],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="absolute top-6 left-2"
              >
                <LiaNode className="text-green-600 text-4xl lg:text-5xl bg-white dark:bg-black shadow-custom dark:shadow-white rounded-full p-1 transition-all duration-300 ease-in-out" />
              </m.div>

              <m.div
                animate={{
                  x: [0, -10, 0],
                  y: [0, -10, 0],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="absolute -top-3 right-16"
              >
                <SiReact className="text-teal-300 text-4xl lg:text-5xl bg-white dark:bg-black shadow-custom dark:shadow-white rounded-full p-1 transition-all duration-300 ease-in-out" />
              </m.div>

              <m.div
                animate={{
                  x: [0, 10, 0],
                  y: [0, 10, 0],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="absolute top-40 -left-5 lg:-left-8"
              >
                <RiTailwindCssFill className="text-sky-400 text-4xl lg:text-5xl bg-white dark:bg-black shadow-custom dark:shadow-white rounded-full p-1.5 transition-all duration-300 ease-in-out" />
              </m.div>

              <m.div
                animate={{
                  x: [20, 10, 20],
                  y: [10, 10, 10],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="absolute -bottom-2 left-16"
              >
                <PiFigmaLogoFill className="text-pink-400 text-4xl lg:text-5xl bg-white dark:bg-black shadow-custom dark:shadow-white rounded-full p-1 transition-all duration-300 ease-in-out" />
              </m.div>

              <m.div
                animate={{
                  x: [20, 10, 20],
                  y: [0, 10, 0],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="absolute bottom-8 right-8"
              >
                <TbSeo className="text-blue-500 text-4xl lg:text-5xl bg-white dark:bg-black shadow-custom dark:shadow-white rounded-full p-2 transition-all duration-300 ease-in-out" />
              </m.div>

              <m.div
                animate={{
                  x: [10, 10, 10],
                  y: [0, 10, 0],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="absolute top-20 -right-2"
              >
                <ImSvg className="text-amber-500 text-4xl lg:text-5xl bg-white dark:bg-black shadow-custom dark:shadow-white rounded-full p-2 transition-all duration-300 ease-in-out" />
              </m.div> */}
              </>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-20 mt-16">
            <div className="relative inline-block -ml-5 sm:ml-6">
              {/* Outer dashed border box */}
              <div className="relative h-[160px] w-[160px] rotate-45 rounded-3xl border border-dashed border-gray-400 flex items-center justify-center">
                {/* Inner background box with visible gap */}
                <div className="h-[150px] w-[150px] bg-gray-50 dark:bg-gray-100/15 rounded-3xl flex items-center justify-center">
                  {/* Upright text */}
                  <div className="-rotate-45 text-center">
                    <p className="-mt-4">Link:</p>
                    {project.link === "Coming Soon" ? (
                      <p>
                        <b>Coming Soon</b>
                      </p>
                    ) : (
                      <a
                        href={project.link}
                        target="_blank"
                        rel="noreferrer"
                        className="font-semibold hover:text-teal-600"
                      >
                        Visit&nbsp;Project
                      </a>
                    )}

                    <p className="mt-2">Contact:</p>
                    <a
                      href="tel:+919664570369"
                      target="_blank"
                      rel="noreferrer"
                      className="font-semibold hover:text-teal-600"
                    >
                      Let's <br /> Collaborate
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <p className="text-justify">{project.description2}</p>
          </div>

          {!isImageScroll_Project ? (
            // {/* For all projects */}
            <>
              {/* Buttons → ONLY on sm and above */}
              {!isMobileScreen && (
                <div className="flex justify-center gap-4 mt-16">
                  {hasLaptop && (
                    <button
                      onClick={() => setActiveView("laptop")}
                      className={`px-6 py-2 rounded-full text-sm font-medium transition
                ${
                  activeView === "laptop"
                    ? "bg-teal-600 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
                    >
                      View in Laptop
                    </button>
                  )}

                  {hasMobile && (
                    <button
                      onClick={() => setActiveView("mobile")}
                      className={`px-6 py-2 rounded-full text-sm font-medium transition
                ${
                  activeView === "mobile"
                    ? "bg-teal-600 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
                    >
                      View in Mobile
                    </button>
                  )}
                </div>
              )}

              {/* ================= PREVIEW AREA ================= */}
              <div
                className={`flex flex-wrap gap-16 mt-10 mb-24 w-full justify-center items-center`}
              >
                {/* ================= LAPTOP VIEW ================= */}
                {hasLaptop && activeView === "laptop" && !isMobileScreen && (
                  <div className="hidden md:block">
                    <div className="relative w-[90vw] h-[50vw] xl:w-[1200px] lg:h-[580px] flex items-center justify-center bg-black/90 rounded-[1rem] border-[8px] border-gray-600">
                      {/* Camera */}
                      <div className="absolute top-3 left-1/2 -translate-x-1/2 w-[80px] h-[10px] bg-gray-600 rounded-full" />

                      {/* Screen */}
                      <div className="absolute inset-[10px] bg-black rounded-[0.5rem] overflow-hidden">
                        <iframe
                          src={project.link}
                          title="Laptop Preview"
                          className="w-full h-full border-0"
                          loading="lazy"
                        />
                      </div>

                      {/* Base */}
                      <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 w-[105%] h-6 bg-gray-600 rounded-b-2xl"></div>
                      <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 w-[60%] h-2 bg-gray-500 rounded-b-full"></div>
                    </div>
                  </div>
                )}

                {/* ================= MOBILE VIEW ================= */}
                {hasMobile && (activeView === "mobile" || isMobileScreen) && (
                  <div className="relative sm:mt-10 md:mt-0 w-[350px] h-[650px] bg-gradient-to-b from-gray-900 to-black rounded-[1.8rem] border-[5px] border-gray-600 overflow-hidden flex items-center justify-center">
                    {/* Notch */}
                    <div className="absolute top-4 left-1/2 -translate-x-1/2 w-[100px] h-[12px] bg-gray-700 rounded-full" />

                    {/* Screen */}
                    <div className="absolute inset-[8px] bg-black rounded-[1rem] overflow-hidden">
                      <iframe
                        src={project.link}
                        title="Mobile Preview"
                        className="w-full h-full border-0"
                        loading="lazy"
                      />
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            // {/* For Neel and Dresswala */}
            <div
              className={`flex flex-wrap gap-16 mt-24 mb-24 w-full
              ${
                hasLaptop && hasMobile
                  ? "justify-center items-center"
                  : "justify-center items-center"
              }`}
            >
              {/* <div className="flex flex-wrap gap-16 justify-center items-center mt-24 mb-24"> */}
              <div className="hidden sm:block">
                {/* LAPTOP CAROUSEL */}
                {hasLaptop && (
                  <div
                    className="relative w-[90vw] h-[50vw] lg:w-[800px] lg:h-[480px] flex items-center justify-center bg-black/90 rounded-[1rem] border-[8px] border-gray-600 shadow-[0_0_40px_rgba(0,0,0,0.0)]"
                    // onMouseEnter={() => setIsPaused_laptop(true)}
                    // onMouseLeave={() => setIsPaused_laptop(false)}
                  >
                    {/* Arrows */}
                    <button
                      onClick={goPrev_laptop}
                      className="absolute left-4 z-20 bg-black/15 hover:bg-black/40 rounded-full p-2 text-white transition"
                    >
                      <ChevronLeft size={22} />
                    </button>
                    <button
                      onClick={goNext_laptop}
                      className="absolute right-4 z-20 bg-black/15 hover:bg-black/40 rounded-full p-2 text-white transition"
                    >
                      <ChevronRight size={22} />
                    </button>

                    {/* Laptop Frame */}
                    <div className="absolute top-3 left-1/2 -translate-x-1/2 w-[80px] h-[10px] bg-gray-600 rounded-full" />
                    <div className="absolute inset-[10px] bg-black rounded-[0.5rem] overflow-hidden">
                      <AnimatePresence mode="wait">
                        <motion.div
                          key={current_laptop}
                          initial={{ x: "100%" }}
                          animate={{ x: 0 }}
                          exit={{ x: "-100%" }}
                          transition={{
                            duration: transitionDuration,
                            ease: "easeInOut",
                          }}
                          className="absolute w-full h-full overflow-y-auto scroll-smooth"
                        >
                          <a
                            href={project.link}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={images_laptop[current_laptop]}
                              alt=""
                              className="w-full object-contain select-none pointer-events-none bg-gray-200"
                              draggable="false"
                              loading="lazy"
                            />
                          </a>
                        </motion.div>
                      </AnimatePresence>
                    </div>

                    {/* 💻 Laptop Base */}
                    <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 w-[105%] h-6 bg-gray-600 rounded-b-2xl mt-1 shadow-[0_8px_20px_rgba(0,0,0,0.0)]"></div>
                    {/* 💻 Laptop Bottom Plate */}
                    <div className="absolute -bottom-10 left-1/2 -translate-x-1/2  w-[60%] h-2 bg-gray-500 rounded-b-full"></div>
                  </div>
                )}
              </div>

              {/* MOBILE CAROUSEL */}
              {hasMobile && (
                <div
                  className="relative w-[300px] h-[600px] bg-gradient-to-b from-gray-900 to-black rounded-[1.8rem] border-[5px] border-gray-600 shadow-[0_0_40px_rgba(0,0,0,0.0)] overflow-hidden flex items-center justify-center"
                  // onMouseEnter={() => setIsPaused_mobile(true)}
                  // onMouseLeave={() => setIsPaused_mobile(false)}
                >
                  {/* Mobile Notch */}
                  <div className="absolute top-4 left-1/2 -translate-x-1/2 w-[100px] h-[12px] bg-gray-700 rounded-full"></div>

                  {/* Arrows */}
                  <button
                    onClick={goPrev_mobile}
                    className="absolute left-3 z-20 bg-black/15 hover:bg-black/40 rounded-full p-2 text-white transition"
                  >
                    <ChevronLeft size={18} />
                  </button>

                  <button
                    onClick={goNext_mobile}
                    className="absolute right-3 z-20 bg-black/15 hover:bg-black/40 rounded-full p-2 text-white transition"
                  >
                    <ChevronRight size={18} />
                  </button>

                  {/* Mobile Frame */}
                  <div className="absolute inset-[8px] bg-black rounded-[1rem] overflow-hidden">
                    <AnimatePresence mode="wait">
                      <motion.div
                        key={current_mobile}
                        initial={{ x: "100%" }}
                        animate={{ x: 0 }}
                        exit={{ x: "-100%" }}
                        transition={{
                          duration: transitionDuration,
                          ease: "easeInOut",
                        }}
                        className="absolute w-full h-full overflow-y-auto scroll-smooth"
                      >
                        <a href={project.link} target="_blank" rel="noreferrer">
                          <img
                            src={images_mobile[current_mobile]}
                            alt=""
                            className="w-full object-contain pointer-events-none select-none bg-gray-200"
                            draggable="false"
                            loading="lazy"
                          />
                        </a>
                      </motion.div>
                    </AnimatePresence>
                  </div>
                </div>
              )}
            </div>
          )}

          <div className="lg:px-[3%]">
            <hr className="mt-16 mb-5 border-t border-teal-500 dark:border-teal-600" />

            <div className="text-sm">
              <div className="flex items-center -ml-[6px]">
                <div className="h-[3px] w-4 bg-teal-600 rotate-90 rounded-t-sm" />

                <p className="font-medium uppercase">Other Services</p>
              </div>

              <div className="grid grid-cols-1 sm:flex sm:flex-wrap gap-x-5 gap-y-3 mt-4">
                <a
                  href="/services/website-designing-and-development"
                  className="font-normal text-gray-400 hover:text-teal-600"
                >
                  Website Designing & Development
                </a>

                <a
                  href="/services/e-commerce-development"
                  className="font-normal text-gray-400 hover:text-teal-600"
                >
                  E-Commerce Development
                </a>

                <a
                  href="/services/software-development"
                  className="font-normal text-gray-400 hover:text-teal-600"
                >
                  Software Development
                </a>

                <a
                  href="/services/mobile-app-development"
                  className="font-normal text-gray-400 hover:text-teal-600"
                >
                  Mobile App Development
                </a>

                <a
                  href="/services/written-production"
                  className="font-normal text-gray-400 hover:text-teal-600"
                >
                  Written Production
                </a>

                <a
                  href="/services/management-services"
                  className="font-normal text-gray-400 hover:text-teal-600"
                >
                  Management Services
                </a>

                <a
                  href="/services/wordpress"
                  className="font-normal text-gray-400 hover:text-teal-600"
                >
                  WordPress
                </a>

                <a
                  href="/services/seo"
                  className="font-normal text-gray-400 hover:text-teal-600"
                >
                  SEO
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </m.div>
  );
};

export default ProjectCaseStudy;
